import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import SportCouponImpl from './sport-coupon.js';
const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * A generic module designed for rendering sport-specific coupons.
 *
 * @class SportCoupon
 * @extends Mojito.Core.Presentation.UIControllerView
 * @memberof Mojito.Modules
 */

/**
 * `SportCoupon` prop types.
 *
 * @property {string} sportId - The sport id.
 * @property {string} couponId - Id associated with the coupon.
 *
 * @memberof Mojito.Modules.SportCoupon
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    couponId: PropTypes.string.isRequired,
};

export default UIControllerView('SportCoupon', SportCouponImpl, propTypes);
